import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { api } from "../lib/api";
import { track } from "../lib/analytics";
import { useLocale } from "../context/LocaleContext";
import { Button } from "./ui/button";

export function Newsletter() {
  const { locale, t } = useLocale();
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | done | error
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/newsletter", { email, locale, consent: true });
      track("newsletter_signup", { locale });
      setState("done"); setEmail("");
    } catch {
      setState("error");
    } finally { setBusy(false); }
  }

  return (
    <section className="container-page mt-24">
      <div className="relative overflow-hidden rounded-3xl brand-gradient px-6 py-14 text-white sm:px-12">
        <div className="relative z-10 max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-[0.15em]">
            <Mail className="h-3.5 w-3.5" /> Newsletter
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black leading-tight sm:text-4xl">{t("newsTitle")}</h2>
          <p className="mt-3 text-white/90">{t("newsSub")}</p>
          {state === "done" ? (
            <div data-testid="newsletter-success" className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/20 px-5 py-3 font-semibold">
              <Check className="h-5 w-5" /> {t("newsSuccess")}
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 flex flex-col gap-3 sm:flex-row">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder={t("newsPlaceholder")} data-testid="newsletter-email"
                className="h-12 flex-1 rounded-full border-0 px-5 text-slate-900 outline-none focus:ring-4 focus:ring-white/40" />
              <Button type="submit" disabled={busy} data-testid="newsletter-submit"
                className="h-12 rounded-full bg-white px-7 font-semibold text-emerald-700 hover:bg-white/90">
                {busy ? "…" : t("newsCta")}
              </Button>
            </form>
          )}
          {state === "error" && <p className="mt-3 text-sm text-white/90">{t("newsError")}</p>}
        </div>
      </div>
    </section>
  );
}
